/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum UserTier {
  OPEN = 'open',
  FREE = 'free',
  ENTERPRISE_TRIAL = 'enterprise_trial',
  ENTERPRISE = 'enterprise',
  PRO = 'pro',
  ULTRA = 'ultra',
  STANDARD = 'standard',
  TEAMS_STANDARD = 'teams_standard',
  TEAMS_PRO = 'teams_pro',
  TEAMS_ULTRA = 'teams_ultra',
  SUPERNINJA_STANDARD = 'superninja_standard',
  SUPERNINJA_PRO = 'superninja_pro',
  SUPERNINJA_ULTRA = 'superninja_ultra',
  SUPERNINJA_MAX = 'superninja_max',
  BUSINESS_SUPERNINJA_PRO = 'business_superninja_pro',
  BUSINESS_SUPERNINJA_ULTRA = 'business_superninja_ultra',
  BUSINESS_SUPERNINJA_MAX = 'business_superninja_max',
  CREDIT_PRO = 'credit_pro',
  CREDIT_BUSINESS_PRO = 'credit_business_pro',
  INTERNAL_UNLIMITED = 'internal_unlimited',
  TEAMS_SUPERNINJA_ULTRA = 'teams_superninja_ultra',
  SUPERNINJA_ULTRA_TRIAL = 'superninja_ultra_trial',
  ULTRA_TRIAL = 'ultra_trial',
  STANDARD_TRIAL = 'standard_trial',
  API_TIER_1 = 'api_tier_1',
  TESTING = 'testing',
  TEAM = 'team',
  PAID = 'paid',
  PRO_TRIAL = 'pro_trial',
}
